import { useLocale } from "next-intl";
import { BlockRenderer } from "@/components/block-renderer";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { useGetCartFaq } from "@/features/cart/api/hooks/use-get-cart-faq";
import { cn } from "@/lib/utils";

export const CartFaq = ({ className }: { className?: string }) => {
  const { data } = useGetCartFaq();
  const locale = useLocale();
  if (!data || locale !== "cz") {
    return null;
  }
  return (
    <div
      className={cn(
        "relative mt-4 bg-brand-grey4 p-6 md:rounded-lg lg:-mx-6",
        className,
      )}
    >
      <Carousel
        className={cn("max-sm:-mx-4 max-sm:[&>div]:pl-4", {
          "lg:pointer-events-none": data.faq?.length && data.faq.length <= 4,
        })}
        opts={{
          align: "start",
        }}
      >
        <CarouselContent className="last:mr-12 lg:last:mr-0">
          {data.faq.map((faq) => {
            return (
              <CarouselItem
                className="flex max-w-full basis-2/3 sm:basis-1/2 md:basis-[30%] lg:basis-1/4"
                key={`faq-${faq.id}`}
              >
                <div className={cn("rounded-lg bg-brand-grey2 p-6")}>
                  <p className="mb-4 font-bold text-xl leading-7">
                    {faq.title}
                  </p>
                  <BlockRenderer content={faq.content} />
                </div>
              </CarouselItem>
            );
          })}
        </CarouselContent>
      </Carousel>
    </div>
  );
};
